<template>
	<div id="media-slider-v2">
		<vueper-slides
			ref="vueperslides1"
			:fixed-height="true"
			:loop="true"
			:touchable="false"
			:bullets="false"
			:arrows="false"
			transition-speed="150"
			:dragging-distance="70"
			prevent-y-scroll
			fade
			autoplay
			class="media-slider no-shadow container"
		>
			<vueper-slide
				v-for="(item) in block.items"
				:key="item.id"
				:image="getSlideImage(item)"
				:style="getSlideStyles(item)"
				class="media-slider-item panel theme-image"
			>
				<template #content>
					<div class="slider__footer">
						<div class="slider__footer__wrapper title_block pl-0">
							<div
								v-if="item.date && item.switch_type_to_section"
								class="date mb-3"
							>
								{{ item.date | moment('DD MMMM YYYY') }}<span
									v-if="$i18n.locale ==='ru'"
								>. {{ item.section }}</span>
							</div>
							<div
								v-else-if="item.date"
								class="date mb-4"
							>
								{{ item.date | moment('DD MMMM YYYY') }}<span
									v-if="$i18n.locale ==='ru'"
								>. {{ item.taxonomy_type }}</span>
							</div>
							<div class="title-h1 slider__footer__title mb-5">
								{{ item.title }}
							</div>

							<div class="media-slider__actions d-flex">
								<div class="media-slider__arrows d-flex">
									<div class="arrow-wrapper" @click="$refs.vueperslides1.previous()">
										<span class="icon icon-chevron-thin-left" />
									</div>
									<div class="arrow-wrapper" @click="$refs.vueperslides1.next()">
										<span class="icon icon-chevron-thin-right" />
									</div>
								</div>
								<nuxt-link
									:to="url(item)"
									class="media-slider__button btn btn-lg btn-primary"
								>
									Узнать больше
								</nuxt-link>
							</div>
						</div>
					</div>
				</template>
			</vueper-slide>
		</vueper-slides>
	</div>
</template>

<script>
import '@/utils/moment';
import panel from '~/mixins/panel';
import { HEADER_IMAGE_POSITIONS, BOOTSTRAP_BREAKPOINTS } from '~/utils/dictionaries';
import checkScreenWidth from '@/mixins/checkScreenWidth';

export default {
	name: 'PanelMediaSliderV2',
	mixins: [panel, checkScreenWidth],
	data() {
		return {
			headerStyle: '',
			BOOTSTRAP_BREAKPOINTS,
			headerImagePosition: '',
			isMobile: true,
		};
	},
	watch: {
		screenWidth() {
			this.isMobile = this.screenWidth < BOOTSTRAP_BREAKPOINTS.md;
		},
	},
	methods: {
		url(item) {
			if (!item) return '/';

			const {
				slug,
				lang,
				taxonomy_type_slug: taxonomyTypeSlug,
			} = item;

			if (!taxonomyTypeSlug || !slug) return '/';

			return `/${taxonomyTypeSlug}/${slug}/`;
		},
		getSlideImage(item) {
			if (!item) return '';

			const {
				mobile_image_image_url_default: mobile,
				listing_cover_image_url_default: listing,
				top_cover_image_url_default: top,
			} = item;

			if (this.isMobile) {
				return mobile?.startsWith('https') ? mobile : top || listing;
			}

			return listing?.startsWith('https') ? listing : top || '';
		},
		getSlideStyles(item) {
			const { mobile_image_center_position_translation_ru: imagePosition } = item;

			if (imagePosition && this.isMobile) {
				return {
					backgroundPosition: HEADER_IMAGE_POSITIONS[imagePosition] || imagePosition,
				};
			}
			return {};
		},
	},
};
</script>
<style lang="scss">
@import "assets/styles/sk_variables";
// For use bootstrap vars and mixins inside
@import "assets/styles/bootstrap/scss/functions";
@import "assets/styles/bootstrap/scss/variables";
@import "assets/styles/bootstrap/scss/mixins";

#media-slider-v2 {

	.vueperslides.container {
		@include media-breakpoint-down(xs) {
			padding-right: 0 !important;
			padding-left: 0 !important;
		}
	}

	.vueperslide {
		background-position: center center;
	}

	.vueperslides--fixed-height .vueperslide,
	.vueperslides--fixed-height .vueperslides__inner,
	.vueperslides--fixed-height .vueperslides__parallax-wrapper {
		min-height: 648px;
		border-bottom-left-radius: 1rem;
		border-bottom-right-radius: 1rem;

		@include media-breakpoint-down(xs) {
			border-bottom-left-radius: 0rem;
			border-bottom-right-radius: 0rem;
		}

		@include media-breakpoint-up(lg) {
			min-height: 576px;
		}

	}

	.vueperslides__inner {
		background-color: $theme-dark;
	}

	.vueperslides--fade .vueperslide {
		transition-duration: 1s;
	}
}
</style>

<style lang="scss" scoped>
@import "assets/styles/sk_variables";
// For use bootstrap vars and mixins inside
@import "assets/styles/bootstrap/scss/functions";
@import "assets/styles/bootstrap/scss/variables";
@import "assets/styles/bootstrap/scss/mixins";

.vueperslides--fixed-height {
	margin-top: 4.5rem;
	height: 100%;
	min-height: 576px;
	width: 100%;
}

.arrow-wrapper {
	width: 2.6rem;
	height: 2.6rem;
	display: flex;
	justify-content: center;
	align-items: center;
	background-color: transparent;
	border: 1px solid white;
	padding: 0.3rem;
	border-radius: 50%;

	@include media-breakpoint-up(lg) {
		width: 3rem;
		height: 3rem;
	}

	&:hover {
		background-color: #1432d1;
		border-color: #1432d1;
		transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out;
	}
}

.media-slider {
	position: relative;
	.slider {
		&__footer {
			position: relative;
			display: flex;
			height: 100%;
			align-items: flex-end;

			&__wrapper {
				display: flex;
				flex-direction: column;
				align-items: flex-start;
				width: 100%;
				@include media-breakpoint-up(md) {
					width: 75%;
				}

				&.title_block {
					.title-h1 {
						font-size: 2rem;
						font-weight: 500;
						word-spacing: -0.2rem;
						line-height: 1.2;
						i {
							word-break: break-word;
						}
					}
					.title {
						margin-bottom: 0;
						font-size: 1.5rem;
						font-weight: 500;
						line-height: 1.2;
						color: $white;
					}
					@include media-breakpoint-up(md) {
						.title {
							font-size: 2rem;
						}
					}
					@include media-breakpoint-up(lg) {
						.title-h1 {
							font-size: 2.3rem;
						}
						.title {
							font-size: 2rem;
						}
					}
				}

			}

			&__title {
				color: white !important;
				font-weight: 500;
			}
		}
	}

	&__actions {
		gap: 1.5rem;
	}

	&__arrows {
		gap: 0.5rem;
	}

	&__button {
		font-size: 1rem;
		@include media-breakpoint-up(lg) {
			font-size: 1.25rem;
		}
	}

	.theme-image {
		@include overlay_shadow(0.6);
		position: absolute;
	}
}

.media-slider-item {
	cursor: pointer !important;
	padding-left: 1rem !important;
	padding-right: 1rem !important;
	min-width: 100%;
}
</style>
